<template>
  <v-card>
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="6">
          <v-text-field class="input-text-size" label="Sale Year"
           v-model="editItem.resaleSaleYear" type="number" />
          </v-col>
          <v-col cols="6">
          <ClarionDateControl class="input-text-size" :isToggle="false"
           v-model="editItem.resaleSaleDate" label="Sale Date" />
          </v-col>
          <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n5" label="Sale Location"
           v-model="editItem.resaleSaleLocation" />
          </v-col>
          <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n5" label="Sale Location Address"
           v-model="editItem.resaleSaleLocationAddOne" />
          </v-col>
          <v-col cols="6">
          <ClarionDateControl class="input-text-size mt-n9" :isToggle="false"
            v-model="editItem.lienDate" label="Lien Date" />
          </v-col>
          <v-col cols="6">
          <ClarionDateControl class="input-text-size pa-0 mt-n9" :isToggle="false"
           v-model="editItem.resalePublicationDate" label="Publication Date" />
          </v-col>
          <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n5" label="Name of Newspaper"
           v-model="editItem.nameOfNewspaper" />
          </v-col>
          <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n5" label="City of Publication"
           v-model="editItem.cityOfPublication" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <label class="input-text-size">
          Payout Priority:</label>
        <v-row>
          <v-col class="d-flex">
            <v-text-field class="input-text-size pa-0 mr-1" label="Taxes"
             v-model="editItem.resaleTaxes" type="number" />
            <v-text-field class="input-text-size pa-0 mr-1" label="Penalty"
             v-model="editItem.resalePenalty" type="number" />
            <v-text-field class="input-text-size pa-0 mr-1" label="Fees"
             v-model="editItem.resaleFees" type="number" />
            <v-text-field class="input-text-size pa-0" label="Special Assessments"
             v-model="editItem.resaleSA" type="number" />
          </v-col>
        </v-row>
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
        label="Print 2/3 Assessed on Public Resale List"
        v-model="editItem.twoByThirdOnPublicResaleListFlag" />
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
        label="Print Parcel ID as description on Public Resale list"
        v-model="editItem.printParcelPublicResaleListFlag" />
        <v-radio-group v-model="editItem.combinedOrIndividualDeed" row>
        <v-row>
          <label class="input-text-size pl-3">Deeds: </label>
          <v-col cols="5" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Print Combined Deeds"
            value="combined">
            </v-radio>
          </v-col>
          <v-col cols="5" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Print Individual Deeds"
            value="individual">
            </v-radio>
          </v-col>
        </v-row>
        </v-radio-group>
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
        label="Documentary Exception on All Deeds"
        v-model="editItem.documentaryExceptionOnAllDeeds" />
        <v-radio-group v-model="editItem.bidAwardSheetVersion" row>
        <v-row>
          <label class="input-text-size pl-3">Bid Award Sheet: </label>
          <v-col cols="4" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Version 1" value="versionOne" />
          </v-col>
          <v-col cols="4" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Version 2" value="versionTwo" />
          </v-col>
        </v-row>
        </v-radio-group>
      </v-col>
    <v-col cols="6">
      <v-radio-group v-model="editItem.certMailerRelease" row>
        <v-row>
          <label class="input-text-size pl-3"> Cert Mail: </label>
          <v-col cols="2" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Old"
            value="old">
            </v-radio>
          </v-col>
          <v-col cols="4" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="New"
            value="new">
            </v-radio>
          </v-col>
        </v-row>
        </v-radio-group>
        <v-radio-group v-model="editItem.noticePostedBy" row>
        <v-row>
          <label class="input-text-size pl-3"> Notice Posted By: </label>
          <v-col cols="4" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Sheriff's Department"
            value="sheriff">
            </v-radio>
          </v-col>
          <v-col cols="4" class="mt-n4">
            <v-radio
            class="input-text-size radio-and-checekbox-size"
            label="Treasurer's Office"
            value="treasurer">
            </v-radio>
          </v-col>
        </v-row>
        </v-radio-group>
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
         label="Sort by Parcel Components"
         v-model="editItem.resaleSortByParcelComponents" />
        <label class="input-text-size">Notification Letters:</label>
        <v-text-field class="input-text-size pa-0" label="Addressee"
        v-model="editItem.resaleAddressee" />
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
         label="Display Total Due (based on Penalty Date)"
         v-model="editItem.resaleDisplayTotalDue" />
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
         label="Print Address at Top of Letter" v-model="editItem.resalePrintAddressAtTop" />
        <v-checkbox class="input-text-size radio-and-checekbox-size mt-n4"
         label="Include Mobile Home Disclaimer"
         v-model="editItem.resaleIncludeMobileHomeDisclaimer" />
         <v-text-field class="input-text-size pa-0 mt-n2" label="Tax Deed Line"
         v-model="editItem.resaleTaxDeedLine" />
         <v-text-field class="input-text-size pa-0 mt-n2" label="Payment Options Line"
         v-model="editItem.resalePaymentOptionsLine" />
         <v-row>
           <v-col cols="10" class="pb-0">
             <v-text-field class="input-text-size pa-0 mt-n2" label="Optional Line 1"
             v-model="editItem.resaleOptionsLine1" />
           </v-col>
           <v-col cols="2" class="pb-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.resaleOptionsLine1Flag" label="RED" />
           </v-col>
           <v-col cols="10" class="pt-0 pb-0">
             <v-text-field class="input-text-size pa-0 mt-n2" label="Optional Line 2"
             v-model="editItem.resaleOptionsLine2" />
           </v-col>
           <v-col cols="2" class="pt-0 pb-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.resaleOptionsLine2Flag" label="RED" />
           </v-col>
           <v-col cols="10" class="pt-0 pb-0">
             <v-text-field class="input-text-size pa-0 mt-n2" label="Optional Line 3"
             v-model="editItem.resaleOptionsLine3" />
           </v-col>
           <v-col cols="2" class="pt-0 pb-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.resaleOptionsLine3Flag" label="RED" />
           </v-col>
           <v-col cols="10" class="pt-0 pb-0">
             <v-text-field class="input-text-size pa-0 mt-n2" label="Optional Line 4"
             v-model="editItem.resaleOptionsLine4" />
           </v-col>
           <v-col cols="2" class="pt-0 pb-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.resaleOptionsLine4Flag" label="RED" />
           </v-col>
         </v-row>
        </v-col>
        <v-col cols="6">
        <label class="input-text-size">Commissioners Sale:</label>
        <v-row>
          <v-col cols="6">
            <label class="input-text-size ml-5">Publication Dates:</label>
            <ClarionDateControl class="input-text-size ml-5" :isToggle="false"
            v-model="editItem.commissionerPubDateOne" label="Date 1" />
            <ClarionDateControl class="input-text-size ml-5 mt-n4" :isToggle="false"
            v-model="editItem.commissionerPubDateTwo" label="Date 2" />
            <ClarionDateControl class="input-text-size ml-5 mt-n4" :isToggle="false"
            v-model="editItem.commissionerPubDateThree" label="Date 3" />
          </v-col>
          <v-col cols="6">
            <ClarionDateControl class="input-text-size mt-7" :isToggle="false"
            v-model="editItem.commissionerDateOfSale" label="Date of Sale" />
            <v-text-field class="input-text-size pa-0 mt-n2" label="Time of Sale"
             v-model="editItem.commissionerTimeOfSale" />
          </v-col>
          <label class="input-text-size ml-5">Commissioner Deeds: </label>
          <v-col cols="12" class="pt-0 pb-0">
            <v-radio-group v-model="editItem.commissionerCombinedOrIndividualDeed" row>
            <v-row>
              <v-col cols="5" class="mt-n4">
                <v-radio
                class="input-text-size radio-and-checekbox-size"
                label="Print Combined Deeds"
                value="combined">
                </v-radio>
              </v-col>
              <v-col cols="5" class="mt-n4">
                <v-radio
                class="input-text-size radio-and-checekbox-size"
                label="Print Individual Deeds"
                value="individual">
                </v-radio>
              </v-col>
            </v-row>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <v-text-field class="input-text-size pa-0 mt-n2" label="Commissioner Chair"
             v-model="editItem.commissionerChair" />
             <ClarionDateControl class="input-text-size" :isToggle="false"
               v-model="editItem.commissionerDateOfMeeting" label="Date of Commissioner Meeting" />
            </v-col>
            <v-col cols="6">
            <v-text-field class="input-text-size pa-0 mt-n2" label="Sale Fees"
             v-model="editItem.commissionerSaleFees" @blur="roundAmount('commissionerSaleFees')"
              @focus="amountToNum('commissionerSaleFees'), $event.target.select()" />
          </v-col>
        </v-row>
        </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="update">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClarionDateControl from '../common/ClarionDateControl.vue';
import {
  pickResaleConfigFields,
  resaleConfigScope,
} from '../../util/shared/system-config-scopes';
import { amountFormat, amountToNumber, cloneItem } from '../../util/shared/vue-global';
import '../../assets/style.css';

export default {
  components: {
    ClarionDateControl,
  },
  data: () => ({
    originalResaleSetting: null,
  }),
  created() {
    this.handleOnCreated();
  },
  computed: {
    ...mapState({
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
    }),
    editItem() {
      return this.resaleSettingItem;
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    async handleOnCreated() {
      await this.loadConfig({ requiredScope: 'resaleConfig' });
      // Combining commissioners sale deeds is opt-in: a county that has never touched this must
      // land on Print Individual Deeds, not on an unselected pair of radios. The deed report reads
      // anything other than 'combined' as individual, so this only makes the screen say what the
      // report already does.
      if (!this.editItem.commissionerCombinedOrIndividualDeed) {
        this.editItem.commissionerCombinedOrIndividualDeed = 'individual';
      }
      // no saved config has this key yet, and a key added by v-model alone is not reactive in
      // Vue 2 - seed it so the checkbox actually toggles on the first visit
      if (this.editItem.documentaryExceptionOnAllDeeds === undefined) {
        this.$set(this.editItem, 'documentaryExceptionOnAllDeeds', false);
      }
      this.originalResaleSetting = cloneItem(this.editItem);
    },
    buildResaleConfigItem() {
      return pickResaleConfigFields(this.editItem);
    },
    mergeResaleConfigForSave() {
      return resaleConfigScope.mergeForPersist(this.editItem);
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'resaleConfig',
          item: this.mergeResaleConfigForSave(),
          previousItem: this.originalResaleSetting,
          isLogAudit: true,
        };
        const ok = await this.updateConfig(payload);
        if (ok) {
          this.originalResaleSetting = cloneItem(this.editItem);
        }
      }
    },
    roundAmount(val) {
      const formatedAmt = amountFormat(amountToNumber(this.editItem[val]));
      this.editItem[val] = formatedAmt;
    },
    amountToNum(val) {
      const formatedAmt = amountToNumber(this.editItem[val]);
      this.editItem[val] = formatedAmt;
    },
  },
};
</script>
